import { initiateApi } from '@witmetrics/api-client';
import { getApiUrl } from './urls';

export const API_CONFIG = {
  baseUrl: getApiUrl(),
  withCredentials: true,
};

export const API = initiateApi(API_CONFIG);
